(function () {
  var attempts = 0;

  function initAtgGsapAnimations(container) {
    if (!window.gsap) {
      attempts += 1;

      if (attempts < 40) {
        window.setTimeout(function () {
          initAtgGsapAnimations(container);
        }, 100);
      }

      return;
    }

    attempts = 0;

    var root = container || document;

    if (window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      window.gsap.set(root.querySelectorAll('[data-atg-animate]'), { clearProps: 'all', opacity: 1 });
      return;
    }

    window.gsap.utils.toArray(root.querySelectorAll('[data-atg-animate]')).forEach(function (element) {
      if (element.getAttribute('data-atg-animated') === 'true') {
        return;
      }

      element.setAttribute('data-atg-animated', 'true');

      var animationType = element.getAttribute('data-atg-animate') || 'fade-up';
      var delay = parseFloat(element.getAttribute('data-atg-delay') || '0');
      var duration = parseFloat(element.getAttribute('data-atg-duration') || '0.8');
      var triggerStart = element.getAttribute('data-atg-start') || 'top 85%';
      var stagger = parseFloat(element.getAttribute('data-atg-stagger') || '0');
      var staggerTarget = element.getAttribute('data-atg-stagger-target');
      var targets = staggerTarget
        ? element.querySelectorAll(staggerTarget)
        : element.hasAttribute('data-atg-stagger-children')
        ? element.children
        : element;
      var fromVars = {
        autoAlpha: 0,
        duration: duration,
        delay: delay,
        ease: 'power3.out'
      };

      if (animationType === 'fade-left') {
        fromVars.x = 48;
      } else if (animationType === 'fade-right') {
        fromVars.x = -48;
      } else if (animationType === 'scale-in') {
        fromVars.scale = 0.94;
      } else {
        fromVars.y = 42;
      }

      if (window.ScrollTrigger) {
        fromVars.scrollTrigger = {
          trigger: element,
          start: triggerStart,
          once: true
        };
      }

      if (stagger > 0) {
        fromVars.stagger = stagger;
      }

      window.gsap.from(targets, fromVars);
    });

    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  }

  function initAtgHeroPieScroll(container) {
    var root = container || document;
    var heroList = [];
    root.querySelectorAll('.hero-floating-pie').forEach(function (pie) {
      var hero = pie.closest('.hero');
      if (hero && heroList.indexOf(hero) === -1) {
        heroList.push(hero);
      }
    });

    heroList.forEach(function (hero) {
      if (hero.getAttribute('data-atg-pie-scroll-init') === 'true') {
        return;
      }

      var pies = hero.querySelectorAll('.hero-floating-pie');
      if (!pies.length) {
        return;
      }

      hero.setAttribute('data-atg-pie-scroll-init', 'true');

      var ticking = false;

      function updatePieScroll() {
        var rect = hero.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var progress = Math.abs(Math.min(rect.top, 0)) / Math.max(viewportHeight * 0.75, 1);
        progress = Math.max(0, Math.min(1, progress));

        pies.forEach(function (pie, index) {
          var isMobile = window.matchMedia('(max-width: 767px)').matches;
          var distance = index % 2 === 0 ? 360 : 300;
          if (isMobile) {
            distance = index % 2 === 0 ? 75 : 50;
          }
          pie.style.transform = 'translate3d(0, ' + (progress * distance * -1).toFixed(2) + 'px, 0)';
        });

        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(updatePieScroll);
          ticking = true;
        }
      }

      updatePieScroll();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  }

  function initAtgSharedStepsLineScroll(container) {
    var root = container || document;

    root.querySelectorAll('.atg-shared-steps').forEach(function (steps) {
      if (steps.getAttribute('data-atg-line-scroll-init') === 'true') {
        return;
      }

      steps.setAttribute('data-atg-line-scroll-init', 'true');

      var ticking = false;

      function updateLineProgress() {
        var rect = steps.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var start = viewportHeight * 0.78;
        var end = viewportHeight * 0.32;
        var progress = (start - rect.top) / Math.max(start - end, 1);
        progress = Math.max(0, Math.min(1, progress));

        steps.style.setProperty('--atg-steps-line-progress', progress.toFixed(3));
        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(updateLineProgress);
          ticking = true;
        }
      }

      updateLineProgress();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  }

  function initAtgFloatingMiddleScroll(container) {
    var root = container || document;

    root.querySelectorAll('.atg-floating-middle').forEach(function (floatingMiddle) {
      if (floatingMiddle.getAttribute('data-atg-floating-middle-scroll-init') === 'true') {
        return;
      }

      floatingMiddle.setAttribute('data-atg-floating-middle-scroll-init', 'true');

      var scrollTarget = floatingMiddle.querySelector('.atg-floating-middle__scroll') || floatingMiddle;
      var scrollAnchor = floatingMiddle.closest('.atg-seam-anchor') || floatingMiddle;
      var ticking = false;

      function updateFloatingMiddle() {
        var rect = scrollAnchor.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var start = viewportHeight * 0.92;
        var end = viewportHeight * 0.18;
        var progress = (start - rect.top) / Math.max(start - end, 1);
        progress = Math.max(0, Math.min(1, progress));

        var distance = window.matchMedia('(max-width: 767px)').matches ? -40 : -180;
        scrollTarget.style.transform = 'translate3d(0, ' + (progress * distance).toFixed(2) + 'px, 0)';
        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(updateFloatingMiddle);
          ticking = true;
        }
      }

      updateFloatingMiddle();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAtgGsapAnimations(document);
      initAtgHeroPieScroll(document);
      initAtgSharedStepsLineScroll(document);
      initAtgFloatingMiddleScroll(document);
    });
  } else {
    initAtgGsapAnimations(document);
    initAtgHeroPieScroll(document);
    initAtgSharedStepsLineScroll(document);
    initAtgFloatingMiddleScroll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAtgGsapAnimations(event.target);
    initAtgHeroPieScroll(event.target);
    initAtgSharedStepsLineScroll(event.target);
    initAtgFloatingMiddleScroll(event.target);
  });
})();
